import React from "react";
import { createSelector } from "reselect";
import isEqual from "lodash.isequal";
import {useAppSelector} from "../../redux/hooks";
import type { RootState } from "../../redux/store";

import { rowDataDeFormatter, rowsDataFormatter } from "./utils";
import Table from "./TableComponents/Table/Table";
import { TableFilters } from "./TableComponents";

import { sellerProductsService, tableService } from "../../api";
import {IProductsRequest} from "../../api/services/sellerProductsService";
import warehousesService from "../../api/services/warehousesService";
import {warehouseTypeLabels} from "../../components/Tables/WarehouseTable/parse-warehouse-type";
import {WarehouseType} from "../../constants/Warehouses/WarehouseType";
import Icon from "../../components/commons/Icons";
import {
    editRowDataElement, setRowData,
    setStockToProductAtWarehouse,
    unsetStockOfProductAtWarehouse
} from "../../redux/stocks/reducer";
import stockService from "../../api/services/stocksService";
import { t } from "i18next";
import {
    IColumnData,
    IFilterOptionsWrapper,
    IRowData,
    ITableSettings,
    ITableSettingsLegacy
} from "../../constants/Table/interfaces";
import {attributes} from "js-cookie";

const memoizedSelector = createSelector((state: RootState) =>
    state.sellers.currentSeller.info.data?.id,
    (sellerId) => ({ sellerId })
)

const TableWrapper: React.FC = () => {

    const [rowData, setRowData] = React.useState<IRowData[]>([]);
    const [rowDataLoading, setRowDataLoading] = React.useState<boolean>(true);
    const [columnData, setColumnData] = React.useState<any[]>([
        { Header: 'ID LK', accessor: 'id', id: "id", sticky: "left",minWidth: 75, width: 75, maxWidth: 75, float: "right", channel: null, part: null},
        { Header: 'Артикул', accessor: 'attributes.attributes_system_sku', id: "sku", sticky: "left", minWidth: 140, maxWidth: 400, float: "right", channel: "system", part: "attributes"},
        { Header: 'Штрих-код', accessor: 'attributes.attributes_system_barcode', id: "barcode", minWidth: 125, width: 125, maxWidth: 125, float: "left", channel: "system", part: "attributes"},
        { Header: 'Бренд', accessor: 'attributes.attributes_system_brand', id: "brand", minWidth: 125, width: 125, maxWidth: 125, float: "left", channel: "system", part: "attributes"},
        { Header: 'Заметки', accessor: 'attributes.attributes_system_notes', id: "notes", minWidth: 125, width: 125, maxWidth: 125, float: "left", channel: "system", part: "attributes"},
        { Header: 'Наименование', accessor: 'attributes.attributes_system_name', id: "name", minWidth: 300, width: "100%", maxWidth: "100%", float: "left", channel: "system", part: "attributes"},
        { Header: 'К продаже', accessor: 'attributes.stocks_null_availableForPurchase', id: "availableForPurchase", minWidth: 140, width: 140, maxWidth: 140, float: "right", channel: "system", part: "stocks"},
        { Header: 'В резерве', accessor: 'attributes.stocks_null_reserved', id: "reserved", minWidth: 140, width: 140, maxWidth: 140, float: "right", channel: "system", part: "stocks"},
        { Header: 'В наличии', accessor: 'attributes.stocks_null_inStock', id: "inStock", minWidth: 140, width: 140, maxWidth: 140, float: "right", channel: "system", part: "stocks"},
    ]);
    const [productsRequestError, setProductsRequestError] = React.useState<string>("");
    const [totalProducts, setTotalProducts] = React.useState<number>(0);
    const [tableSettings, setTableSettings] = React.useState<ITableSettings>({ limit: 10, page: 1, order: {} });
    const [tableSettingsLoaded, setTableSettingsLoaded] = React.useState<boolean>(false);
    const [tableSettingsToEqualCheck, setTableSettingsToEqualCheck] = React.useState<IFilterOptionsWrapper>();

    const { sellerId } = useAppSelector(memoizedSelector);

    const initialRequestData: IProductsRequest = {
        limit: tableSettings.limit,
        page: tableSettings.page,
        order: tableSettings.order,
        // filter: tableSettings.filter,
        sellerID: sellerId,
        withStocks: true,
        withStocksSum: true,
        channels: ["system"],
    }

    React.useEffect(() => {
        if(sellerId) {
            tableService.getTableSettings(sellerId, 'stocksFBS', true)
            .then((res) => {
                if (res.data) {
                    console.log(res)
                }
            })
        }
    })

    React.useEffect(() => {
        if(sellerId) {
            setRowDataLoading(true);
            sellerProductsService.getTableProducts(initialRequestData)
            .then((res) => {
                if (Object.keys(res.data.data).length) {
                    let formattedProducts = rowsDataFormatter(res.data.data.items);
                    console.log(formattedProducts)

                    let finalObjAttr: any = {};
                    console.log(res.data.data.stocksSum)
                    res.data.data.stocksSum.forEach((row: any) => {
                        finalObjAttr[`${row.type}`] = row.data.quantity;
                    })

                    formattedProducts.unshift({
                        attributes: {
                            stocks_null_availableForPurchase: finalObjAttr.availableForPurchase,
                            stocks_null_reserved: finalObjAttr.reserved,
                            stocks_null_inStock: finalObjAttr.inStock
                        }
                    })

                    setRowData(formattedProducts);
                    setColumnData([...columnData]);
                    setTotalProducts(res.data.data.total);
                    setRowDataLoading(false);
                }


                // Ошибка в получении данных objectObject
                // warehousesService.getWarehousesForSeller(sellerId)
                //     .then(
                //         (res) => {
                //             if (res.data.success) {
                //
                //                 const customSort = (a: any, s: string[]) => {
                //                     return a.sort(function(x1: any, x2: any) {
                //                         let i1 = s.indexOf(x1.type),
                //                             i2 = s.indexOf(x2.type);
                //                         return i1 < 0 ? 1 : i2 < 0 ? -1 : i1 - i2;
                //                     })
                //                 }
                //
                //                 const newObj = customSort(res.data.data, ['fbs', 'supplier', 'external_fbs', 'external_fbo']);
                //
                //                 newObj.forEach((wh: { name: string, uuid: string, status: string, type: string, externalService: any }) => {
                //
                //                     if (wh.status !== 'active') {
                //                         return;
                //                     }
                //
                //                     const colId: string = `wh_${wh.uuid}`
                //                     if (!columnData.find(({ id }) => id === colId)) {
                //                         columnData.push({
                //                             Header:
                //                                 <>
                //                                     <div className={"float-left w-[100%] min-w-[50%]"}>
                //                                         <p className={'truncate text-ellipsis text-right'}>
                //                                             {wh.name}
                //                                         </p>
                //                                         <div className="text-c-light-black font-normal text-right">
                //                                             <span>{t<string>(warehouseTypeLabels[wh.type]) ?? ''}</span>
                //                                         </div>
                //                                     </div>
                //                                     {(wh.externalService) !== '' ?
                //                                         <div className={"ml-2 float-right w-[35%]"}>
                //                                             { wh.externalService === WarehouseType.ExternalWarehouseFBS || WarehouseType.ExternalWarehouseFBO ?
                //                                                 <Icon width={30} height={30} marketSource={wh.externalService} />
                //                                                 :
                //                                                 null
                //                                             }
                //                                         </div>
                //                                         :
                //                                         null
                //                                     }
                //                                 </>,
                //                             Footer: wh.name,
                //                             accessor: `attributes.wh_${wh.uuid}`,
                //                             id: colId,
                //                             minWidth: 140, width: 140, maxWidth: 140, float: "right", fieldType: "number"
                //                         })
                //                     }
                //
                //                     setColumnData([...columnData])
                //
                //                     //feel warehouses type
                //                     rowData.forEach((row, i) => {
                //
                //                         row = {
                //                             ...row,
                //                             attributes: {
                //                                 ...row.attributes,
                //                                 [colId]: {
                //                                     warehouseType: wh.type,
                //                                     externalService: wh.externalService
                //                                 }
                //                             }
                //                         }
                //
                //                         rowData[i] = row
                //                         setRowData([row])
                //                     })
                //                 })
                //             }
                //             // disableIsNeedUpdateData(10)
                //         },
                //         (err) => {
                //             setProductsRequestError(err.response.data.error);
                //             // disableIsNeedUpdateData(10)
                //         }
                //     )
                //     .catch((err) => {
                //         setProductsRequestError(err.message);
                //         // disableIsNeedUpdateData(10)
                //     });

            })
            .catch(err => {
                setProductsRequestError(err.message);
                setRowDataLoading(false);
                setTableSettingsLoaded(true);
            }).finally(() => {
                setRowDataLoading(false);
                setTableSettingsLoaded(true);
            })
        }
    }, [sellerId, tableSettingsLoaded, tableSettings])

     // save and get options logic

    //  React.useEffect(() => {
    //     if (tableSettings && tableSettingsLoaded && columnData && sellerId) {
    //         tableService.setTableSettings(sellerId, tableSettings, columnData)
    //             .catch(err => console.error(`При сохранении настроек таблицы произошла ошибка: ${err.message}`))
    //     }
    // }, [tableSettings, tableSettingsLoaded, columnData])

    // check if search filters isnt equal to tableSettings

    // React.useEffect(() => {
    //     if (tableSettingsToEqualCheck) {
    //         if (!isEqual(tableSettingsToEqualCheck, tableSettings.filter)) {
    //             setTableSettings((prev: any) => {
    //                 return {
    //                     ...prev,
    //                     filter: tableSettingsToEqualCheck
    //                 }
    //             })
    //         }
    //     }
    // }, [tableSettingsToEqualCheck])

    if(!sellerId) {
        return null;
    }

    const updateProduct = (rowIndex: number, columnHeader: string, value: string) => {
        const product = updateRowData(rowIndex, columnHeader, value);
        let deFormattedProduct = rowDataDeFormatter(product);

        sellerProductsService.changeSellerProduct({ product: deFormattedProduct, sellerId: sellerId })
            .catch(err => console.error(err.message))
    }

    const updateRowData = (rowIndex: number, columnHeader: string, value: string) => {
        let productToUpdate;
        columnHeader = columnHeader.split(".")[1] ? columnHeader.split(".")[1] : columnHeader
        setRowData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return productToUpdate = {
                        ...old[rowIndex],
                        attributes: { ...old[rowIndex].attributes, [columnHeader]: value }
                    }
                }
                return row
            })
        )
        return productToUpdate
    }

    // delete columns and rows handlers

    const deleteRow = (data: IRowData) => {
        if (Array.isArray(data) && data.length > 0) {
            let oldArr = [...rowData];
            let rowsToDelete: Array<IRowData> = [];
            data.forEach((obj: IRowData) => {
                rowsToDelete.push(obj)
                oldArr = oldArr.filter(item => item.id !== obj.id);
            })
            setRowData(oldArr);
            // deleteRowFromServer(rowsToDelete);
        } else if (Object.keys(data).length > 0) {
            let filteredRows = rowData.filter(item => item.id !== data.id);
            setRowData(filteredRows);
            // deleteRowFromServer(data);
        }
    }

    // const deleteRowFromServer = (data: IRowData | Array<IRowData>) => {
    //     sellerProductsService.deleteSellerProduct({ product: data, sellerId: sellerId })
    //         .catch(err => console.error(err.message))
    // }

    const addColumn = (column: IColumnData) => {
        setColumnData([...columnData, column]);
    }

    const deleteColumn = (column: IColumnData) => {
        const dataWithoutColumn = columnData.filter(item => item.Header !== column.Header);
        setColumnData(dataWithoutColumn);
    }

    // toggle pin column handler

    const togglePinColumnHandler = (data: any) => {
        const columnAccessor = columnData.find(item => item.id === data.id)?.accessor;
        let withoutThisColumn = columnData.filter(item => item.Header !== data.Header);
        if (data.hasOwnProperty("sticky") && data.sticky && columnAccessor) {
            setColumnData([...withoutThisColumn, { Header: data.Header, id: data.id, Cell: data.Cell, accessor: columnAccessor, minWidth: data.minWidth, width: data.width, maxWidth: data.maxWidth, float: data.float }])
        } else if (columnAccessor) {
            let arrOfColumns = [...withoutThisColumn, { Header: data.Header, accessor: columnAccessor, id: data.id, sticky: "left", Cell: data.Cell, minWidth: data.minWidth, width: data.width, maxWidth: data.maxWidth, float: data.float }];
            let withSticky: (IColumnData)[] = [];
            let withoutSticky: (IColumnData)[] = [];
            arrOfColumns.forEach(item => item.hasOwnProperty("sticky") && item.sticky ? withSticky.push(item) : withoutSticky.push(item));
            setColumnData([...withSticky, ...withoutSticky])
        }
    }



    return (
        <div className="p-3">
            <div className='flex flex-col md:flex-row justify-between'>
                {/*{sellerId &&*/}
                {/*    <TableFilters*/}
                {/*        fields={columnData}*/}
                {/*        sellerId={sellerId}*/}
                {/*        setTableSettings={setTableSettings}*/}
                {/*        tableSettings={tableSettings}*/}
                {/*    />*/}
                {/*}*/}
                <div className='mt-4 md:mt-0 w-full max-w-full '>
                    <div className='flex flex-col'>
                    {sellerId &&
                        <Table
                            setColumnData={setColumnData}
                            togglePinColumnHandler={togglePinColumnHandler}
                            tableSettingsLoaded={tableSettingsLoaded}
                            setRowDataLoading={setRowDataLoading}
                            totalProducts={totalProducts}
                            columns={columnData}
                            tableSettings={tableSettings}
                            setTableSettings={setTableSettings}
                            data={rowData}
                            updateProduct={updateProduct}
                            addColumn={addColumn}
                            deleteColumn={deleteColumn}
                            deleteRow={deleteRow}
                            rowDataLoading={rowDataLoading}
                            productsRequestError={productsRequestError}
                            setTableSettingsToEqualCheck={setTableSettingsToEqualCheck}
                        />
                    }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TableWrapper;